import { render, staticRenderFns } from "./retrieveDetails.vue?vue&type=template&id=2ba5c625&scoped=true"
import script from "./retrieveDetails.vue?vue&type=script&lang=js"
export * from "./retrieveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba5c625",
  null
  
)

export default component.exports